// const Manage = () => import('@/view/home/manage') //挂载主页面
// const loaderComponent = () => import(/* webpackChunkName: "Manage" */ '@/utils/loaderComponent')
export default (btnRloe, data) => {
    routerFilter(btnRloe, data)
}
function routerFilter(btnRloe, data) {
    data.forEach(item => {
        if (item.btns && item.btns.length) {
            btnRloe.push(...item.btns)
        }
        if (item.children && item.children.length) {
            routerFilter(btnRloe, item.children)
        }
    })
}



// WEBPACK FOOTER //
// ./src/utils/getBtnRole.js